import { render, staticRenderFns } from "./FabTemplateBooks.vue?vue&type=template&id=94f87642&scoped=true&"
import script from "./FabTemplateBooks.vue?vue&type=script&lang=js&"
export * from "./FabTemplateBooks.vue?vue&type=script&lang=js&"
import style0 from "./FabTemplateBooks.vue?vue&type=style&index=0&id=94f87642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f87642",
  null
  
)

export default component.exports